// extracted by mini-css-extract-plugin
export default {"tableHeadCell":"styles_tableHeadCell__JUPa0","tableBodyCell":"styles_tableBodyCell__2LQLO","unsignedActRow":"styles_unsignedActRow__7li77"};